export default {"src":"/_next/static/media/cloudLightning_64.49b5527b.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};